import React, { useMemo, useState } from "react";
import {Table, Tag } from "antd";
import { getFormattedDate } from "modules/utilities/utility";
import _ from "lodash";
import { Link } from "react-router-dom";
import moment from "moment";

const bookingFlag = ['website_lead_booking', 'app_lead_booking']

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    render: (text, record) => (
      <div className="d-flex flex-column">
        <Link to={`/lead-details/${record.case_id}`}>{record.name}</Link>
      </div>
    ),
  },
  {
    title: "Gender",
    dataIndex: "gender",
  },
  {
    title: "Order Id",
    dataIndex: "order_display_id",
    render: (text, record) => (
      <div>
        {`${record.order_display_id}-`}
        <span>
          <Tag color="blue">{record.order_count}</Tag>
        </span>
      </div>
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Tag",
    dataIndex: "tag",
    render: (text, record) => (
      <div className="d-flex flex-wrap">
        {record.tag.map((item) => {
          return (
            item&&<Tag color="blue" key={item}>
              {item}
            </Tag>
          );
        })}
        {
          bookingFlag.includes(record?.request_type) && <Tag color="blue" key={record?.unanswered_count}>
           Reattempt:{record?.unanswered_count}
        </Tag>
        }
      </div>
    ),
  },
  {
    title: "New/Repeat",
    dataIndex: "order_count",
    sorter: (a, b) => a.order_count - b.order_count,
    render: (order_count, key) => {
      if (order_count <= 1)
        return (
          <Tag color="blue" key={key}>
            NEW
          </Tag>
        );
      else
        return (
          <Tag color="cyan" key={key}>
            REPEAT ORDER {order_count}
          </Tag>
        );
    },
  },
  {
    title: "Due Date",
    dataIndex: "due_date",
    sorter: (a, b) => moment(a.due_date).diff(moment(b.due_date)),
  },
  {
    title: "Temporarily Assigned To",
    dataIndex: "temp_agent",
  },
  {
    title: "Merged",
    dataIndex: "slot_booked",
  },
];
const MedrepEngagementTable = ({
  filterData,
  engLoading,
  selectedRowKeys,
  setSelectedRowKeys,
}) => {

  const mappedData = useMemo(() => {
    return filterData?.length
      ? filterData.map((item) => {
          const isRescheduled = item?.reschedule_count !== 0;
          const isSlotBooked = item?.is_slot_booked;
          const leadColdSlot = item?.request_type === "lead_cold_slot" ? "Lead" : null;
          const tag = [
            item?.tag,
            isRescheduled ? "Rescheduled" : null,
            isSlotBooked ? "Slot Booking" : null,
            leadColdSlot ? leadColdSlot : null
          ];
          const orderType =
            item?.order?.count <= 1 || !item?.order?.count
              ? "New"
              : `Repeat ${item.order.count}`;

          return {
            tag,
            name: _.get(item, ["case", "user", "first_name"], ""),
            phone_number: _.get(item, ["rep", "phone_number"], ""),
            gender:
              _.get(item, ["case", "user", "gender"], "") === "M"
                ? "Male"
                : "Female",
            status: _.get(item, "status", ""),
            order_type: orderType,
            due_date: getFormattedDate(_.get(item, "reminder_date")),
            temp_agent: _.get(
              item,
              ["temporary_assignment", "first_name"],
              "N/A"
            ),
            slot_booked: isSlotBooked ? "Yes" : "No",
            order_display_id: _.get(item, ["order", "order_display_id"], "N/A"),
            order_count: _.get(item, ["order", "count"], "0"),
            key: item._id,
            case_id: item.case_id,
            unanswered_count: item?.unanswered_count,
            request_type : item?.request_type
          };
        })
      : [];
  }, [filterData]);


  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <div>
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={mappedData}
        loading={engLoading}
      />
    </div>
  );
};
export default MedrepEngagementTable;
